import { types, getRoot } from 'mobx-state-tree'
import { IRoot } from 'src/api/stores/Root/types'
import { INodeConnectedComponent } from './types'

export const NodeConnectedComponent: INodeConnectedComponent = types.model().views(self => {
  const root = getRoot<IRoot>(self)
  return {
    get routeState() {
      return root.routeState
    }
  }
})
